import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FlashMessagesService } from "angular2-flash-messages";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { PfArtfileComponent } from '../pf-artfile/pf-artfile.component';
import { DragulaService } from 'ng2-dragula';

export interface DialogData {
  inkColors: any;
  active_artwork_loc: string;
  selectedInkColor: any;
  selectedInkColorObj: any;
  projects: any;
  activeProjectIndex: any;
  active_location_arr: any;
  artworkPrintOpt: any,
  selectedAdons: any,
  maxInkLength: number,
  section: string,
  artworkHexColors: any,
  otherPrintSettings: any,
  activeStep: any,
  tmp_location_images: any,
  upd_location_images: any,
  inkChangeData: any,
  inkChangeObj: any,
  active_image_loc: string

}
@Component({
  selector: 'app-ink-color-picker',
  templateUrl: './ink-color-picker.component.html',
  styleUrls: ['./ink-color-picker.component.css']
})
export class InkColorPickerComponent implements OnInit {
  public t = 0;
  public onImagePreview = false;
  public imgWidth = 0;
  public imgHeight = 0;
  public isUploading = false;
  public isArtworkLoaded = false;
  public artworkFiles = [];
  public artworkSrc = null;
  public imp_upload_error = null;
  public artwork_img = null;
  public selectedFile = null;
  public src = null;
  public isShowAssign = false;
  public imageUrl: string;
  private cx: CanvasRenderingContext2D;
  public isOpenDirectColorReplacer = false;
  public isOpenDirectInkChangeReplacer = false;
  public isOpenInkChangeReplacer = false;
  @ViewChild("canvas") canvas;
  public tmpInkChangeData = {};
  public activeIndexChangeReplace = null;
  public activeInkChangeReplaceObj = null;
  public mainInkChangekey = null;
  public isAddChange = false;
  public testData = {};


  constructor(public dialogRef: MatDialogRef<InkColorPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _flashMessagesService: FlashMessagesService,
    private CommonProjectDataService: CommonProjectDataService,
    private CommonService: CommonService,
    private dialog: MatDialog,
    private dragula: DragulaService
  ) { }

  ngOnInit() {
    let dragIndex: number, dropIndex: number;
    this.dragula
      .drag('bag-items')
      .subscribe((value: any) => {
        dragIndex = value.el.id;
        if (this.data.tmp_location_images) {
          this.clickTouch(this.data.tmp_location_images.splice(dragIndex, 1));
        }

      });



  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  checkSelectedColor(inkObj, locs) {
    return locs &&
      this.data.selectedInkColor &&
      this.data.selectedInkColor[this.data.active_artwork_loc] &&
      this.data.selectedInkColor[this.data.active_artwork_loc].indexOf(
        inkObj.ink_id
      ) >= 0
      ? true
      : false;
  }

  manageInkColor(inkObj) {
    if (!this.data.selectedInkColorObj[this.data.active_artwork_loc]) {
      this.data.selectedInkColorObj[this.data.active_artwork_loc] = [inkObj];
      this.data.selectedInkColor[this.data.active_artwork_loc] = [inkObj.ink_id];

      //$scope.$emit("validatePrintMethod", { isprintValidated: true });
    } else {
      let currTarget = this.data.selectedInkColor[this.data.active_artwork_loc];
      if (currTarget && currTarget.indexOf(inkObj.ink_id) >= 0) {
        if (!this.isColorInkChanged(inkObj.ink_id)) {
          let checkIndex = currTarget.indexOf(inkObj.ink_id);
          currTarget.splice(checkIndex, 1);
          this.data.selectedInkColorObj[this.data.active_artwork_loc].splice(checkIndex, 1);
          if (currTarget.length == 0) {
            // delete $scope.artwork_hex_colors[$scope.active_artwork_loc];
            //delete this.inkChangeData[$scope.active_artwork_loc];
          }
        }
        // delete $scope.selectedInkColorObj[$scope.active_artwork_loc][checkIndex]
      } else {
        if (this.checkMaxRange(0)) {
          currTarget.push(inkObj.ink_id);
          this.data.selectedInkColorObj[this.data.active_artwork_loc].push(inkObj);
          //$scope.$emit("validatePrintMethod", { isprintValidated: true });
        }
      }
    }
    let compactArray = this.data.selectedInkColorObj[this.data.active_artwork_loc].filter(function (item) {
      return item !== undefined;
    });
  }

  isColorInkChanged(inkId) {
    let isColorInkChanged = false;
    //check if ink change  out setting for color : start 27 March
    if (this.data.projects.projects_data[this.data.activeProjectIndex].active_location_arr && this.data.projects.projects_data[this.data.activeProjectIndex].active_location_arr.length > 0) {
      let tmpTotalChangedColor = [];

      this.data.projects.projects_data[this.data.activeProjectIndex].active_location_arr.map((cLocs) => {
        let isInkChangeDataEmpty = this.isObjectEmpty(this.data.projects.projects_data[this.data.activeProjectIndex].inkChangeData[cLocs]);
        if (!isInkChangeDataEmpty && this.data.projects.projects_data[this.data.activeProjectIndex].inkChangeData[cLocs]['colorChange'] && !this.isObjectEmpty(this.data.projects.projects_data[this.data.activeProjectIndex].inkChangeData[cLocs]['colorChange'])) {
          let tmpColorChange = this.data.projects.projects_data[this.data.activeProjectIndex].inkChangeData[cLocs]['colorChange'];
          if (Object.keys(tmpColorChange).length > 0) {
            Object.keys(tmpColorChange).forEach((pval, pkey) => {
              if (Object.keys(tmpColorChange[pval]).length > 0) {
                Object.keys(tmpColorChange[pval]).forEach((spval, spkey) => {
                  if (tmpColorChange[pval][spval].org && tmpColorChange[pval][spval].org.ink_id) {
                    tmpTotalChangedColor = tmpTotalChangedColor.concat(tmpColorChange[pval][spval].org);
                  }
                })
              }
            })
          }
        }
      });
      if (tmpTotalChangedColor.length > 0) {
        let isChangeOut = [];
        isChangeOut = tmpTotalChangedColor.filter(function (compData) {
          return (compData.ink_id == inkId) ? inkId : null;
        });
        if (isChangeOut.length > 0) {
          this._flashMessagesService.show("Can't Remove : You have Ink Change-Out settings present for this Color", { cssClass: 'alert-warning', timeout: 2000 });
          isColorInkChanged = true;
        }
      }
    }
    //check if ink change  out setting for color : end 27 March
    return isColorInkChanged;
  }

  isObjectEmpty(temObj) {
    if (temObj) {
      return Object.keys(temObj).length == 0 ? true : false;
    }
    else {
      return true;
    }

  }

  checkMaxRange(isInput) {


    if (this.data.artworkPrintOpt[this.data.active_artwork_loc].locationSetting[this.data.otherPrintSettings[this.data.active_artwork_loc].selectedOptionIndex].matrixType == 'per_color') {
      let maxInkLength = this.data.otherPrintSettings[this.data.active_artwork_loc].priceMatrix.max_ink_length;

      let addoneId = this.data.artworkPrintOpt[this.data.active_artwork_loc].addOns[0]['add_on_id'];
      let inputLength = this.data.selectedAdons[this.data.active_artwork_loc][addoneId].filter(x => x != null && x != '').length;
      let tmpRange = 0;

      if (this.data.selectedInkColor[this.data.active_artwork_loc]) {
        tmpRange = tmpRange + this.data.selectedInkColor[this.data.active_artwork_loc].length;
      }
      let selectedAdonsColor = this.data.selectedAdons[this.data.active_artwork_loc];
      if (selectedAdonsColor) {
        tmpRange = tmpRange + inputLength;
      }

      return ((tmpRange) < maxInkLength) ? true : false;
    }
    else {
      return true;
    }

  }

  isObjValEmpty = function (obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  numToArr(inputNum) {
    return new Array(inputNum);
  }

  uploadFile = function (noOfColor) {
    this.isUploading = true;
    this.isArtworkLoaded = false;
    this.active_uui = this.CommonProjectDataService.getNewUid();
    this.artWorkFile = this.selectedFile;
    this.noOfColor = noOfColor > 0 ? noOfColor : 4;
    var file = this.artWorkFile;
    const uploadedFileOption = new FormData();
    uploadedFileOption.append('id', localStorage.getItem("userID"));
    uploadedFileOption.append('img_name', this.selectedFile);
    uploadedFileOption.append('artwork_id', this.active_uui);
    uploadedFileOption.append('no_of_color', this.noOfColor);

    this.CommonService.apiService(
      "POST",
      "artwork/upload",
      uploadedFileOption
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.isUploading = false;
          this.img_name = response.data.img_name;
          this.artwork_img = response.data.artwork_img;
          // delete this.data.selectedInkColorObj[this.data.active_artwork_loc];
          //delete this.data.inkChangeData[this.data.active_artwork_loc];
          //delete this.data.selectedInkColor[this.data.active_artwork_loc];

          if (!this.data.artworkHexColors[this.data.active_artwork_loc]) {
            this.data.artworkHexColors[this.data.active_artwork_loc] = {
              'active_uui': this.active_uui,
              'artwork_img': response.data.artwork_img,
              'org_file': response.data.img_name,
              'img_ext_path': response.data.img_ext_path
            }
          }
          else {
            this.data.artworkHexColors[this.data.active_artwork_loc]['active_uui'] = this.active_uui;
            this.data.artworkHexColors[this.data.active_artwork_loc]['artwork_img'] = response.data.artwork_img;
            this.data.artworkHexColors[this.data.active_artwork_loc]['org_file'] = response.data.img_name;
            this.data.artworkHexColors[this.data.active_artwork_loc]['img_ext_path'] = response.data.img_ext_path;
          }

          if (response.data.org_file && response.data.org_file_ext_path) {
            this.data.artworkHexColors[this.data.active_artwork_loc].org_file = response.data.org_file;
            this.data.artworkHexColors[this.data.active_artwork_loc].org_file_ext_path = response.data.org_file_ext_path;
            this.data.artworkHexColors[this.data.active_artwork_loc].org_file_type = response.data.org_file_type;
          }
          this.data.activeStep = "steptwo";
          if (this.data.activeStep == "steptwo") {
            //this.dialogRef.close();
            this.dialogRef.close({ activeStep: this.data.activeStep, url: this.data.artworkHexColors[this.data.active_artwork_loc]['img_ext_path'], artwork_img: this.artwork_img });
            //this.callArtfileStepTwo();
            //this.displayCanvasImage(this.data.artworkHexColors[this.data.active_artwork_loc]['img_ext_path'], 'artfile', this.data.active_artwork_loc, 0);
          }

        }
      },
      err => {
        this.isUploading = false;
        console.log("error msg", err.error.message);
      }
    );


  };

  uploadedFile(element) {
    this.onImagePreview = false;
    this.imgWidth = 0;
    this.imgHeight = 0;
    var reader = new FileReader();
    var img = new Image();
    var imgTypeArr = [
      "image/jpeg",
      "image/jpg",
      "image/gif",
      "image/bmp",
      "image/png"
    ];
    reader.onload = (event: any) => {
      this.imp_upload_error = null;
      this.selectedFile = element.target.files[0];
      this.src = event.target.result;
      this.artworkSrc = event.target.result;
      if (element.target.files[0].size > 524288000) {
        this.imp_upload_error = "File too large. File must be less than 500 megabytes.";
      }
      let fileExt = this.selectedFile.name.split('.').pop();
      var validFileTypeArr = [
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "image/bmp",
        "image/png",
        "application/illustrator",
        "image/x-eps",
        "application/postscript",
        "image/x-photoshop",
        "image/vnd.adobe.photoshop",
        "image/tiff",
        "image/svg+xml",
        "application/pdf",
        "application/cdr",
        "application/coreldraw",
        "application/x-cdr",
        "application/x-coreldraw",
        "image/cdr",
        "image/x-cdr"
      ];
      if (fileExt != 'psd') {
        if (validFileTypeArr.indexOf(element.target.files[0].type) < 0 && fileExt != 'cdr') {
          this.imp_upload_error = "Invalid file type. Only JPG, GIF, BMP, PNG, AI, EPS, PDF, PSD, SVG, TIF,CDR types are accepted.";
        }
        if (imgTypeArr.indexOf(element.target.files[0].type) >= 0) {
          //img.src = this.src;
          this.onImagePreview = true;
        }
        else {
          this.onImagePreview = false;
        }
        if (this.imp_upload_error != null) {
          this._flashMessagesService.show(this.imp_upload_error, { cssClass: 'alert-warning', timeout: 5000 });
        }

      }

    }

    if (element) {
      reader.readAsDataURL(element.target.files[0]);
    }
  }

  isArtworkValidated(artwork_img, artwork_hex_colors, active_artwork_loc) {
    let rtData = (artwork_img && artwork_hex_colors[active_artwork_loc] && artwork_hex_colors[active_artwork_loc].img_ext_path) ? true : false;
    return rtData;
  }

  isArtworkImgFileValid(artwork_hex_colors, active_artwork_loc) {
    return (artwork_hex_colors[active_artwork_loc] && artwork_hex_colors[active_artwork_loc].img_ext_path) ? true : false;
  }

  validateArtColor(artwork_hex_colors, active_artwork_loc) {
    return artwork_hex_colors && artwork_hex_colors[active_artwork_loc] && artwork_hex_colors.img_ext_path ? false : true;
  };


  displayCanvasImage(url, artFileType, location, index) {
    this.isShowAssign = false;
    this.imageUrl = url;
    let urlExt = url.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps'].indexOf(urlExt) !== -1) {
      url = 'assets/img/' + urlExt + '.png';
    }
    else {
      url
    }
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    image.src = url;
    canvasEl.width = 500;
    canvasEl.height = 480;
    let imageAspectRatio = image.width / image.height;
    let canvasAspectRatio = canvasEl.width / canvasEl.height;
    let renderableHeight = image.height;
    let renderableWidth = image.width;
    let xStart = (canvasEl.width - image.width) * 0.5;
    let yStart = (canvasEl.height - image.height) * 0.5;

    // If image's aspect ratio is greater than canvas's we fit on width
    // and place the image centrally along height

    if (image.width >= canvasEl.width) {
      renderableWidth = canvasEl.width - 50;
      renderableHeight = image.height * (renderableWidth / image.width);
      xStart = (canvasEl.width - renderableWidth) / 2;
      yStart = (canvasEl.height - renderableHeight) / 2;
    }
    if (image.height > canvasEl.height) {
      renderableHeight = canvasEl.height;
      renderableWidth = image.width * (renderableHeight / image.height);
      xStart = (canvasEl.width - renderableWidth) / 2;
      yStart = 0;
    }
    renderableWidth = renderableWidth == 0 ? 780 : renderableWidth;
    renderableHeight = renderableHeight == 0 ? 480 : renderableHeight;

    this.cx.drawImage(image, xStart, yStart, renderableWidth, renderableHeight);

  }

  closeInkChange(locs) {
    //if (!this.isAddChange) {
    if (Object.keys(this.tmpInkChangeData).length > 0) {
      this.data.inkChangeData[locs]["updData"].push(this.data.upd_location_images);
    }
    if (Object.keys(this.tmpInkChangeData).length == 0 && this.data.upd_location_images) {
      this.data.tmp_location_images = this.data.tmp_location_images.concat(this.data.upd_location_images);
    }
    this.data.inkChangeData[locs]["leftData"] = JSON.parse(JSON.stringify(this.data.tmp_location_images));
    //}
    this.tmpInkChangeData = {};
    //this.data.upd_location_images=[];
    // $scope.tmp_location_images =[];
    if (this.data.inkChangeData[locs]['totalColor'] == 0) {
      this.data.inkChangeData[locs] = {
        updData: [],
        leftData: [],
        colorChange: {},
        totalColor: 0
      };
    }
    this.isAddChange = false;
    this.dialogRef.close();
  }

  clickTouch(loc) {
    this.data.upd_location_images.push(loc[0]);
  }

  resetInkChange(locs, cindex, ctype) {
    let inkChangeObj = {};
    if (ctype == "direct") {
      inkChangeObj = this.data.upd_location_images;
      this.data.upd_location_images = [];
    } else {
      inkChangeObj = this.data.inkChangeData[locs].updData[cindex];
      delete this.data.inkChangeData[locs].updData[cindex];
      delete this.data.inkChangeData[locs].colorChange[cindex];
      this.data.inkChangeData[locs].colorChange = Object.assign({}, Object.values(this.data.inkChangeData[locs].colorChange));
      this.data.inkChangeData[locs].updData.splice(cindex, 1);
    }

    for (var i = 0; i < Object.keys(inkChangeObj).length; i++) {
      this.data.tmp_location_images.push(inkChangeObj[i]);
    }
    this.data.inkChangeData[locs]["totalColor"] = this.countInkChangeColor(this.data.inkChangeData[locs]);
  }
  closeReplacer() {
    this.isOpenInkChangeReplacer = false;
    this.isOpenDirectInkChangeReplacer = false;
    this.tmpInkChangeData = {};
  }

  manageInkChangeColor(icObj, mainInkObj, mainInkIndex) {
    if (this.data.active_artwork_loc) {
      if (!mainInkObj) {
        let tmpIndex = 0;
        if (this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"]) {
          let tmpMainInkIndex =
            this.data.inkChangeData[this.data.active_artwork_loc]["updData"].length;
          tmpIndex = tmpMainInkIndex;
          if (this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"][tmpMainInkIndex]) {
            Object.assign(this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"][tmpMainInkIndex],
              {
                [this.activeIndexChangeReplace]: {
                  upd: icObj,
                  org: this.activeInkChangeReplaceObj
                }
              }
            );
          } else {
            this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"][
              tmpMainInkIndex
            ] = {
              [this.activeIndexChangeReplace]: {
                upd: icObj,
                org: this.activeInkChangeReplaceObj
              }
            };
          }
        } else {
          let tmpMainInkIndex = 0;
          this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"] = {
            [tmpMainInkIndex]: {
              [this.activeIndexChangeReplace]: {
                upd: icObj,
                org: this.activeInkChangeReplaceObj
              }
            }
          };
        }
        this.tmpInkChangeData = JSON.parse(JSON.stringify(this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"][tmpIndex]));
      } else {
        if (this.data.inkChangeData[this.data.active_artwork_loc]) {
          if (
            this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"]
          ) {
            if (this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"][mainInkIndex]) {
              Object.assign(
                this.data.inkChangeData[this.data.active_artwork_loc][
                "colorChange"
                ][mainInkIndex],
                {
                  [this.activeIndexChangeReplace]: {
                    upd: icObj,
                    org: this.activeInkChangeReplaceObj
                  }
                }
              );
            } else {
              this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"][
                mainInkIndex
              ] = {
                [this.activeIndexChangeReplace]: {
                  upd: icObj,
                  org: this.activeInkChangeReplaceObj
                }
              };
            }
          } else {
            this.data.inkChangeData[this.data.active_artwork_loc]["colorChange"] = {
              [mainInkIndex]: {
                [this.activeIndexChangeReplace]: {
                  upd: icObj,
                  org: this.activeInkChangeReplaceObj
                }
              }
            };
          }
        }
      }
      this.isOpenInkChangeReplacer = false;
      this.isOpenDirectInkChangeReplacer = false;
      this.activeIndexChangeReplace = null;
      this.activeInkChangeReplaceObj = null;
      this.mainInkChangekey = null;

      this.data.inkChangeData[this.data.active_artwork_loc]["totalColor"] = this.countInkChangeColor(this.data.inkChangeData[this.data.active_artwork_loc]);
    }
  }

  openInkChangeReplacer(cindex, cobj, mainInkkey, ctype) {
    if (ctype == "direct") {
      this.isOpenDirectInkChangeReplacer = true;
      this.isOpenInkChangeReplacer = false;
    } else {
      this.isOpenInkChangeReplacer = true;
      this.isOpenDirectInkChangeReplacer = false;
    }
    this.activeIndexChangeReplace = cindex;
    this.activeInkChangeReplaceObj = cobj;
    this.mainInkChangekey = mainInkkey;
  }

  removeInkChange(ickey, mIndex) {

  }

  countInkChangeColor(changeArr) {
    let changeColCount = 0
    if (changeArr) {
      if (changeArr.colorChange) {
        Object.keys(changeArr.colorChange).forEach((pval, pkey) => {
          if (changeArr.colorChange[pkey]) {
            changeColCount = changeColCount + Object.keys(changeArr.colorChange[pkey]).length;
          }
        });
      }
    }
    return changeColCount;
  }

  addInkChangeSection() {
    this.isAddChange = true;

    if (this.tmpInkChangeData) {
      this.data.inkChangeData[this.data.active_artwork_loc]["updData"].push(
        this.data.upd_location_images
      );
    }
    if (!this.tmpInkChangeData && this.data.upd_location_images) {
      this.data.tmp_location_images = this.data.tmp_location_images.concat(this.data.upd_location_images);
    }
    this.data.inkChangeData[this.data.active_artwork_loc]["leftData"] = JSON.parse(JSON.stringify(this.data.tmp_location_images));
    this.tmpInkChangeData = {};
    this.data.upd_location_images = [];
  };

  //custom name number funnctions

  generateCol(quantityArr, mval) {

    if (this.data.active_artwork_loc && this.data.section == 'custom') {
      return this.numToArr(Math.max(...mval.quantity));
    }
  };
  closeNameNumber(active_artwork_loc) {
    if (this.data.otherPrintSettings[active_artwork_loc].changeName) {
      let changeName = this.data.otherPrintSettings[active_artwork_loc].changeName;
      let changeNumber = this.data.otherPrintSettings[active_artwork_loc].changeNumber;
      for (let ckey in changeName) {
        let changeNameArr = changeName[ckey];
        let changeNumberArr = changeNumber[ckey];
        for (let vkey in changeNameArr) {
          let changeNameValue = changeNameArr[vkey];
          let changeNumberValue = changeNumberArr[vkey];
          for (let mkey in changeNameValue) {
            if ((changeNumberValue[mkey] == '' || changeNumberValue[mkey] == null || changeNumberValue[mkey] == 0 ) || (changeNameValue[mkey] == '' || changeNameValue[mkey] == null || changeNameValue[mkey] == 0 )) {
              changeNameValue[mkey] = null;
              changeNumberValue[mkey] = null;
            }
          }
        }
      }
    }
    this.dialogRef.close();
  }

  checkNameNumber(qval, colorId, sizeId) {
    if (!this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName']) {
      this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'] = {
        [colorId]: { [sizeId]: new Array(qval).fill(null) }
      }
      this.data.otherPrintSettings[this.data.active_artwork_loc]['changeNumber'] = {
        [colorId]: { [sizeId]: new Array(qval).fill(null) }

      }
      return this.numToArr(qval);
    }
    if (!this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'][colorId]) {

      Object.assign(this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'], {
        [colorId]: { [sizeId]: new Array(qval).fill(null) }
      });
      Object.assign(this.data.otherPrintSettings[this.data.active_artwork_loc]['changeNumber'],
        { [colorId]: { [sizeId]: new Array(qval).fill(null) } });

      return this.numToArr(qval);
    }
    if (this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'] && this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'][colorId]) {
      if (!this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'][colorId][sizeId]) {
        Object.assign(this.data.otherPrintSettings[this.data.active_artwork_loc]['changeName'][colorId], {
          [sizeId]: new Array(qval).fill(null)
        });
        Object.assign(this.data.otherPrintSettings[this.data.active_artwork_loc]['changeNumber'][colorId],
          { [sizeId]: new Array(qval).fill(null) });

      }
      return this.numToArr(qval);
    }
    return this.numToArr(qval);




  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

}












// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/ink-color-picker/ink-color-picker.component.ts